import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { PasswordInput } from "@/components/ui/password-input"
import { Textarea } from "@/components/ui/textarea"
import { Path, UseFormReturn } from "react-hook-form"
import { z } from "zod"
import { cn } from "@/lib/utils"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TextInputField = <Tschema extends z.ZodType<any, any, any>>({
  form,
  name,
  label,
  description,
  placeholder,
  error,
  type = "text",
  required = false,
  infoContent,
  isDisabled = false,
  additionalClassName
}: {
  form: UseFormReturn<z.infer<Tschema>>,
  schema: Tschema,
  name: Path<z.TypeOf<Tschema>>
  description?: string,
  placeholder?: string,
  label: string,
  type?: string,
  error?: boolean,
  required?: boolean,
  infoContent?: React.ReactNode,
  isDisabled?: boolean,
  additionalClassName?: string
}) => {
  const inputFieldClassName = 'w-[400px] bg-foreground text-primary ' + additionalClassName
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel
            className={cn('flex justify-start font-semibold text-primary !text-sm', `${!description ? 'mb-1' : ''}`)}
            isRequired={required}
            infoContent={infoContent}
          >
            {label}
          </FormLabel>
          {description && <p className="text-secondary text-sm font-normal !-mt-1 mb-1 text-left">{description}</p>}
          <FormControl>
            {type === 'password' ? (
              <PasswordInput
                className={inputFieldClassName}
                hasError={error}
                placeholder={placeholder ?? '********'}
                disabled={isDisabled}
                {...field}
              />
            ) : type === 'textarea' ? (
              <Textarea
                className={inputFieldClassName}
                hasError={error}
                placeholder={placeholder ?? 'Enter text here...'}
                disabled={isDisabled}
                {...field}
              />
            ) : (
              <Input
                className={inputFieldClassName}
                hasError={error}
                type={type}
                placeholder={placeholder ?? 'Enter value here...'}
                disabled={isDisabled}
                {...field}
              />
            )}
          </FormControl>
          <FormMessage
            showIcon={true}
            className="flex flex-row justify-start"
          />
        </FormItem>
      )}
    />
  )
}
